import React, { useState, useEffect } from "react";
import { Modal, CloseButton, Tab, Tabs } from "react-bootstrap";
import AdminHeader from "../layout/AdminHeader";
import { ValidatorForm } from "react-form-validator-core";
import TextValidator from "../partial/TextValidator";
import { createDomain, getDomain, getSenderEmail, senderEmail } from "../../actions/auth";
import swal from "sweetalert";
import { getDate } from "../../utils/helper";
import SmsSetting from "./SmsSetting";
import { EMAIL_TEMPLATE_COLUMN } from "./emailTemplateCol";
import { Button } from "react-bootstrap";
import { COLUMNSDOMAIN } from "./columnDomain";

const Setting = () => {
    const [show, setShow] = useState(false);
    const [domain, setDomain] = useState(false);
    const [loader, setLoader] = useState(false);
    const [activeTab, setActiveTab] = useState("email");
    const userID = localStorage.getItem("userId");
    
    const [currency, setCurrency] = useState("INR");
    const [formData, setFormData] = useState({
        id: 0,
        fromEmail: "",
        createdAt: "",
        status: "",
        userId: userID
    });
    
    const [formDomain, setFormDomain] = useState({
        userId: userID,
        domainName: "",
        loginUrl: "",
        email: "",
        password: "",
        createdAt: ""
    });
    
    const { domainName, email, loginUrl, password } = formDomain;
    const { fromEmail } = formData;
    const firstName = localStorage.getItem("name");
    const lastName = localStorage.getItem("lastName");
    const emailData = localStorage.getItem("email");
    const mobileNumber = localStorage.getItem("mobileNumber");
    const availBalance = localStorage.getItem("creditBalance");
    const [response, setResponse] = useState();
    const [responseDomain, setResponseDomain] = useState();
    
    const [formResponse, setFormResponse] = useState();
    const [formResponseDomain, setFormResponseDomain] = useState();


    const fetch = async () => {
        setLoader(true);
        await getSenderEmail(userID)
            .then((res) => {
                setResponse(res.data);
                setLoader(false);
            })
            .catch(() => {
                setLoader(false);
            });
    };
    const fetchDomain = async () => {
        setLoader(true);
        await getDomain(userID)
            .then((res) => {
                setResponseDomain(res.data);
                setLoader(false);
            })
            .catch(() => {
                setLoader(false);
            });
    };


    useEffect(() => {
        fetch()
        fetchDomain();
    }, []);

    useEffect(() => {
        const tempData = response;
        if (tempData) {
            tempData?.forEach((val) => {
                val.id = val.id;
                val.fromEmail = val.fromEmail;
                val.createdAt = getDate(val?.createdAt, "DD-MM-YYYY");
                val.status = val?.status;
            });
        }
        setFormResponse(tempData);
    }, [response]);
    useEffect(() => {
        const tempData = responseDomain;
        if (tempData) {
            tempData?.forEach((val) => {
                val.domainName = val.domainName;
                val.loginUrl = val.loginUrl;
                val.createdAt = getDate(val?.createdAt, "DD-MM-YYYY");
                val.status = val?.status;
            });
        }
        setFormResponseDomain(tempData);
    }, [responseDomain]);

    const handleClose = () => setShow(false);
    const handleCloseDomain = () => setDomain(false);
    const handleCampaigns = () => setShow(true);
    const handleDomain = () => setDomain(true);

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    
    const onChangeDoamin = (e) => {
        setFormDomain({ ...formDomain, [e.target.name]: e.target.value });
    };
    
    const onSubmit = async () => {
        setLoader(true);
        const res = await senderEmail(formData);
        if (res?.message === "Sucess") {
            setShow(false);
            swal({
                position: "center",
                icon: "success",
                title: "User created successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            fetch();
            setActiveTab("email")
            setFormData({ fromEmail: "" });
        } else {
            swal({
                title: "Oops!",
                text: "Failed to create user",
                icon: "warning",
                button: "OK",
                timer: 5000,
            });
        }
        setLoader(false);
    };

    const onSubmitDomain = async () => {
        setLoader(true);
        const res = await createDomain(formDomain);
        if (res?.message === "Sucess") {
            setDomain(false);
            swal({
                position: "center",
                icon: "success",
                title: "Domain created successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            fetchDomain()
            setActiveTab("dummy")
            setFormDomain({
                domainName: "",
                loginUrl: "",
                email: "",
                password: "",
            });
        } else {
            swal({
                title: "Oops!",
                text: "Failed to create domain",
                icon: "warning",
                button: "OK",
                timer: 2000,
            });
        }
        setLoader(false);
    };

    const ActionButtons = () => (
        <div className="d-flex">
            <Button onClick={handleCampaigns} className="btn btn-primary " style={{marginRight:"10px"}}>
                Create User
            </Button>
            <Button onClick={handleDomain} className="btn btn-primary" >
                Create Domain
            </Button>
        </div>
    );

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        {[...Array(8)].map((_, i) => <div key={i}></div>)}
                    </div>
                </div>
            )}
            
            <AdminHeader name={"Setting"} />
            
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customerViewMain">
                        <div className="dashboard__profileSettingsMain">
                            <div className="dashboard__profileSettingsBox">
                                <ValidatorForm className="customForm">
                                    <div className="row">
                                        {[
                                            { label: "First Name", value: firstName },
                                            { label: "Last Name", value: lastName },
                                            { label: "Email", value: emailData },
                                            { label: "Mobile Number", value: mobileNumber },
                                            { label: "Currency", value: currency },
                                            { label: "Available Amount", value: availBalance }
                                        ].map((field, i) => (
                                            <div key={i} className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                                <div className="form-group withIcon">
                                                    <label>{field.label}</label>
                                                    <TextValidator 
                                                        placeholder={field.label} 
                                                        className="form-control" 
                                                        name={field.label} 
                                                        disabled 
                                                        value={field.value} 
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </ValidatorForm>
                            </div>
                        </div>
                    </div>
                    
                    <div className="dashboard__customerViewMain mt-3">
                        <div className="dashboard__profileSettingsMain">
                            <div className="dashboard__profileSettingsBox">
                                <div className="card">
                                    <div className="card-header d-flex justify-content-between align-items-center">
                                        <h4 className="mb-0">Email Settings</h4>
                                        <ActionButtons />
                                    </div>
                                    <div className="card-body p-0">
                                        <Tabs
                                            activeKey={activeTab}
                                            onSelect={setActiveTab}
                                            className="px-3 pt-3"
                                        >
                                            <Tab eventKey="email" title="User">
                                                <div className="p-3">
                                                    <SmsSetting 
                                                        columns={EMAIL_TEMPLATE_COLUMN} 
                                                        data={formResponse || []} 
                                                    />
                                                </div>
                                            </Tab>
                                            <Tab eventKey="dummy" title="Domain">
                                                <div className="p-3">
                                                <SmsSetting 
                                                        columns={COLUMNSDOMAIN} 
                                                        data={formResponseDomain || []} 
                                                    />
                                                </div>
                                            </Tab>
                                        </Tabs>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modals */}
            <Modal show={show} id="showm" onHide={handleClose} centered >
                                            <Modal.Header>
                                                <Modal.Title style={{ fontSize: "20px" }}>Create New User</Modal.Title>
                                                <CloseButton onClick={handleClose} variant="white" />
                                            </Modal.Header>
                                            <Modal.Body>
                                                <ValidatorForm onSubmit={onSubmit} >
                                                    <div className="row">
                                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-12">
                                                            <div className="form-group withIcon">
                                                                <label>Sender Email</label>
                                                                <TextValidator placeholder="Send Email" className="form-control" name="fromEmail" value={fromEmail} validators={["required"]} errorMessages={["Email is required"]} onChange={onChange} />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 py-3">
                                                            <div className="button-section" style={{ float: "inline-end" }}>
                                                                <button type="submit" className="btn btn-primary">
                                                                    Submit
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </ValidatorForm>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="primary" onClick={handleClose}>
                                                    Close
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Modal show={domain} id="showm" onHide={handleCloseDomain} centered size="lg" >
                                            <Modal.Header>
                                                <Modal.Title style={{ fontSize: "20px" }}>Create New Domain</Modal.Title>
                                                <CloseButton onClick={handleCloseDomain} variant="white" />
                                            </Modal.Header>
                                            <Modal.Body>
                                                <ValidatorForm onSubmit={onSubmitDomain} >
                                                    <div className="row">
                                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                            <div className="form-group withIcon">
                                                                <label>Domain Name</label>
                                                                <TextValidator placeholder="Domain Name" className="form-control" name="domainName" value={domainName} validators={["required"]} errorMessages={["Domain Name is required"]} onChange={onChangeDoamin} />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                            <div className="form-group withIcon">
                                                                <label>Login URL</label>
                                                                <TextValidator placeholder="Login URL" className="form-control" name="loginUrl" value={loginUrl} validators={["required"]} errorMessages={["Login URL is required"]} onChange={onChangeDoamin} />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                            <div className="form-group withIcon">
                                                                <label>Email</label>
                                                                <TextValidator placeholder="Email" className="form-control" name="email" value={email} validators={["required"]} errorMessages={["Email is required"]} onChange={onChangeDoamin} />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                            <div className="form-group withIcon">
                                                                <label>Password</label>
                                                                <TextValidator placeholder="Password" className="form-control" name="password" value={password} validators={["required"]} errorMessages={["Password is required"]} onChange={onChangeDoamin} />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 py-3">
                                                            <div className="button-section" style={{ float: "inline-end" }}>
                                                                <button type="submit" className="btn btn-primary">
                                                                    Submit
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </ValidatorForm>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="primary" onClick={handleCloseDomain}>
                                                    Close
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
        </>
    );
};

export default Setting;